import { INFO_TYPE, WARNING_TYPE, SUCCESS_TYPE, ERROR_TYPE } from '@sv-support-sdk/utils/src/constants/notifications';

export const NOTIFICATION_ICONS = {
  [SUCCESS_TYPE]: '22--check-circle-outlined',
  [ERROR_TYPE]: '22--error-outline',
  [WARNING_TYPE]: '22--warning-amber-outlined',
  [INFO_TYPE]: '22--info-outlined',
};
